import SweetAlert from "sweetalert2";

export const togleLoading = (loading) => {
  if (loading === true) {
    SweetAlert.showLoading();
  } else {
    SweetAlert.close();
  }
};
